<div class="container-fluid">
	<div class="row align-items-center mx-0">
		<div class="col">
			<h1 class="my-3 text-capitalize">Puntos Por Articulos</h1>
		</div>
		<div class="col-auto px-0 text-end">
			<button type="button" class="ml-2 btn btn-secondary" [routerLink]="['/add-item-points']">Asignar puntos</button>
		</div>
	</div>

	<!--div>
		<div class="row">
			<div class="col-6 col-md-3 form-group">
				<label class="">Nombre</label>
				<input type="text" name="name" [(ngModel)]="item_points_search.lk.name" class="form-control">
			</div>
			<div class="col-6 col-md-3">
				<label>&nbsp;</label>
				<div>
					<button type="button" class="w-100 btn btn-primary" (click)="search()">Buscar</button>
				</div>
			</div>
		</div>
	</div-->

	<div  class="card p-3 mt-3">
		<app-loading [is_loading]="is_loading"></app-loading>
		<div class="table-responsive">
			<table class="table table-sm table-nowrap mb-0">
				<thead class="thead-light">
					<tr>
						<th>Articulo</th>
						<th>Tipo</th>
						<th>Cantidad/Porcentaje</th>
						<th>Acciones</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let ci of item_points_list">
						<td>
							<a [routerLink]="['/edit-item-points',ci.item_points.id]">{{ci | itemName}}</a>
						</td>
						<td>{{ci.item_points.type == 'AMOUNT' ? 'Cantidad' : 'Porcentaje'}}</td>
						<td>{{ci.item_points.qty}}</td>
						<td>{{ci.item_points.created | shortDate }} </td>
						<td>
							<button type="button" class="btn btn-primary" (click)="deleteItemPoint(ci)">Eliminar</button>
						</td>
					</tr>
					<tr *ngIf="item_points_list.length == 0 && !is_loading" colspan="3">
						<div class="alert alert-light m-3" role="alert">No se encontraron elementos</div>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<app-pagination [path]="path" [pages]="pages" [total_pages]="total_pages" [current_page]="current_page"></app-pagination>
</div>

